import { isValidTextInput } from '@acceligentllc/shared/utils/text';

import type { CalculatedBlockNameForm } from './EditBlockNameModal';

export function validate(values: CalculatedBlockNameForm) {
	const errors: ValidationErrors = {};

	if (!isValidTextInput(values.name)) {
		errors.name = 'Name is required';
	}

	return errors;
}
